module.exports = __webpack_public_path__ + "static/media/bottle.bb412e87.png";